// Import the functions you need from the SDKs you need
import { FirebaseOptions, getApp, getApps, initializeApp } from 'firebase/app'
import { browserLocalPersistence, getAuth, GoogleAuthProvider, OAuthProvider, setPersistence } from 'firebase/auth'
import { getStorage } from 'firebase/storage'

const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.firebaseApiKey,
  authDomain: process.env.firebaseAuthDomain,
  projectId: process.env.firebaseProjectId,
  storageBucket: process.env.firebaseStorageBucket,
  messagingSenderId: process.env.firebaseMessagingSenderId,
  appId: process.env.firebaseAppId,
  measurementId: process.env.firebaseMeasurementId,
}

const firebase_app = !getApps().length ? initializeApp(firebaseConfig) : getApp()

const storage = getStorage(firebase_app)

const auth = getAuth(firebase_app)
// const messaging = getMessaging(firebase_app)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // Persistence đã được set
    console.log('Persistence set successfully')
  })
  .catch((error) => {
    console.error('Error setting persistence:', error)
  })

const googleProvider = new GoogleAuthProvider()
const appleProvider = new OAuthProvider('apple.com')

appleProvider.addScope('email')
appleProvider.addScope('name')

// const requestPermission = async () => {
//     try {
//         const token = await getToken(messaging, { vapidKey: process.env.firebaseVapidKey });
//         if (token) {
//             // console.log('Token retrieved:', token);
//             // Send this token to your server to save it for later use
//         }
//     } catch (err) {
//         console.error('An error occurred while retrieving token. ', err);
//     }
// };

export { auth, googleProvider, appleProvider, firebase_app, storage, firebaseConfig }
